<template>
  <div class="bottom_content_sty">
    <div class="info container">
      <div class="left">
        <div class="news">
          <p>资讯</p>
          <a target="_blank" href="https://www.ypdstudy.com/#/news?type=1"
            >行业资讯</a
          >
          <a target="_blank" href="https://www.ypdstudy.com/#/news?type=2"
            >公司资讯</a
          >
        </div>
        <div class="more_service">
          <p>更多服务</p>
          <router-link :to="{ path: '/helpCenter' }">帮助中心</router-link>
          <a target="_blank" href="https://www.ypdstudy.com/#/allCourses"
            >社会课程</a
          >
          <a target="_blank" href="https://www.ypdstudy.com/#/recruit"
            >人才招聘</a
          >
          <a
            target="_blank"
            href="https://meeting.tencent.com/activities/?fromSource=sem4_gwzcw.3910919.3910919.3910919"
            >直播工具下载</a
          >
        </div>
      </div>
      <div class="mid">
        <div class="app">
          <p>APP下载</p>
          <img src="@/assets/images/code_app.png" alt="" />
        </div>
        <div class="service">
          <p>客服咨询</p>
          <img src="@/assets/images/code_kefu.png" alt="" />
        </div>
        <div class="cooperation">
          <p>商务合作</p>
          <img src="@/assets/images/code_coop.png" alt="" />
        </div>
      </div>
      <div class="right">
        <p class="kefu">
          <img src="@/assets/images/icons/kefu_icon.png" alt="" /> 客服电话
        </p>
        <p class="kefu_phone">183-5926-6483</p>
        <p class="time">服务时间：09:00-22:00</p>
        <p class="email">电子邮件：xiamenypd@163.com</p>
      </div>
    </div>
    <p class="copyright">
      Copyright © 2020 易普道 版权所有
      <a target="_blank" href="https://beian.miit.gov.cn/"
        >闽ICP备2020021594号-3</a
      >
    </p>
  </div>
</template>


<script>
export default {
  data() {
    return {};
  },
};
</script>


<style lang="less" scoped>
.bottom_content_sty {
  padding: 24px 0 12px;
  width: 100%;
  background: rgb(25, 119, 245);
  height: 200px;
  min-width: 1200px;
  .info {
    padding: 0 30px;
    overflow: hidden;
    .left,
    .mid,
    .right {
      display: inline-block;
      // width: 33.33%;
      vertical-align: top;
      &.left {
        float: left;
        width: 33.33%;
        text-align: left;
        color: #fff;
        .news,
        .more_service {
          display: inline-block;
          margin-right: 100px;
          vertical-align: top;
          text-align: center;
          p {
            margin-bottom: 10px;
            text-align: center;
          }
          a {
            display: block;
            line-height: 2;
            transition: all 0.3s ease;
            &:hover {
              color: #eee;
            }
          }
        }
      }
      &.mid {
        float: left;
        width: 33.33%;
        text-align: center;
        .app,
        .service,
        .cooperation {
          display: inline-block;
          margin: 0 12px;
          p {
            margin-bottom: 10px;
            text-align: center;
            color: #fff;
          }
          img {
            width: 100px;
            height: 100px;
          }
        }
      }
      &.right {
        float: right;
        color: #fff;
        text-align: left;
        p {
          line-height: 2;
          &.kefu {
            font-size: 14px;
            img {
              width: 24px;
              height: 24px;
            }
          }
          &.kefu_phone {
            font-size: 18px;
            font-weight: bold;
          }
          &.time,
          &.email {
            font-size: 12px;
            color: #dadada;
          }
        }
      }
    }
  }
  .copyright {
    margin: 12px 0;
    font-size: 12px;
    text-align: center;
    color: #dadada;
    a {
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>